<template>
  <div id="app">
    <!-- <router-view></router-view> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {},
  data() {
    return {
      //   crumbData: '',
      //   list: [],
    }
  },
  watch: {
    // $route() {
    //   console.log('myrouter:', this.$route.matched)
    //   this.crumbData = this.$route.matched.map((m) => m.meta)
    //   const len = this.crumbData.length
    //   this.list = this.crumbData[len - 1]
    //   console.log('crumbData:', this.list.length)
    //   let str = ''
    //   for (let i = 0; i < this.list.length; i++) {
    //     console.log('i:', i)
    //     console.log('crumbData:', this.list[i].name)
    //     if (i == 0) {
    //       str = str + this.list[i].name
    //     } else {
    //       str = str + '>' + this.list[i].name
    //     }
    //   }
    //   console.log('str:', str)
    // },
  },
}
</script>

<style lang="scss">
@import './assets/css/main.scss';
body {
  margin: 0;
}
::-webkit-scrollbar {
  display: none;
}
// .jsc-bg::-webkit-scrollbar {
//   display: none;
// }
.el-message-box {
  width: 80% !important;
}
.el-scrollbar {
  .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
</style>
